import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { activateColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getActivate } from "../../../../api/sim";

const COPY_KEYS = ["id", "iccid", "status", "plan_id", "zipcode", "msisdn"];

const ActivateBatch = () => (
  <BatchDetail
    title="Activate"
    apiGet={__getActivate}
    client={CLIENTS.pwg}
    columnsFactory={(ctx) => activateColumns({ ...ctx, iccidHeaderName: "ESN", msisdnHeaderName: "MDN" })}
    copyKeys={COPY_KEYS}
    exportAction="activate"
    retryOperation="activate"
    showTerminate
    getRowPath={(row) => `/pwg/activate/${row.id}`}
  />
);

export default ActivateBatch;
